// AlphaMeta Contract ABI
export const ALPHAMETA_ABI = [
  "function owner() view returns (address)",
  "function admin() view returns (address)",
  "function token() view returns (address)",
  "function tokenPriceInUSDT() view returns (uint256)",
  "function defaultReferrerId() view returns (uint256)",
  "function totalUsers() view returns (uint256)",
  "function minimumInvestmentUSDT() view returns (uint256)",
  "function investmentMultiple() view returns (uint256)",
  "function roiTimeframe() view returns (uint256)",
  "function getROITimeframe() view returns (uint256)",
  
  "function users(uint256) view returns (address wallet, uint256 id, uint256 referrerId, uint256 totalInvestment, uint256 totalEarned, uint256 pendingRewards, uint256 directReferrals, uint256 teamVolume, uint256 directBusiness, uint256 lastPackageAmount, bool active)",
  "function addressToId(address) view returns (uint256)",
  "function blacklistedUsers(uint256) view returns (bool)",
  "function userClubLevel(uint256) view returns (uint256)",
  
  "function levelPercentages(uint256) view returns (uint256)",
  "function levelRequirements(uint256) view returns (uint256 directBusiness, uint256 selfStaking, uint256 directReferrals)",
  "function clubRequirements(uint256) view returns (uint256 teamBusiness, uint256 directBusiness, uint256 selfStaking, uint256 reward)",
  
  "function getUserInvestmentDetails(uint256 userId) view returns (uint256[] amounts, uint256[] timestamps, uint256[] roiRates, uint256[] roiEarned, uint256[] otherIncomeEarned, uint256[] lastTradeStart, bool[] active, bool[] tradeActive, uint8[] investmentTypes)",
  "function getUserBasicInfo(uint256 userId) view returns (address, uint256, uint256, uint256)",
  "function getUserExtendedInfo(uint256 userId) view returns (uint256, uint256, uint256, bool, bool)",
  "function getUserLevelCounts(uint256 userId) view returns (uint256[15])",
  "function getUserLevelVolumes(uint256 userId) view returns (uint256[15])",
  "function getUserLevelEligibility(uint256 userId) view returns (bool[15])",
  "function getUserClubInfo(uint256 userId) view returns (uint256 clubLevel, bool[8] claimed)",
  "function getDirectReferrals(uint256 userId) view returns (uint256[])",
  "function getUserActivities(uint256 userId, uint256 page, uint256 pageSize) view returns (tuple(uint256 timestamp, uint256 amount, uint8 activityType)[], uint256)",
  "function getContractStats() view returns (uint256, uint256, uint256, uint256, uint256)",
  "function levelUsers(uint256 userId, uint256 level, uint256 index) view returns (uint256)",
  
  "function registerAndInvest(uint256 referrerId, uint256 tokenAmount)",
  "function invest(uint256 tokenAmount)",
  "function startTrade(uint256 investmentIndex)",
  "function claimTradeROI(uint256 investmentIndex)",
  "function claimRewards()",
  
  "event UserRegistered(address indexed userAddress, uint256 indexed userId, uint256 indexed referrerId)",
  "event UserInvestment(address indexed userAddress, uint256 indexed userId, uint256 amount, uint256 tokenAmount)",
  "event TradeStarted(uint256 indexed userId, uint256 investmentIndex, uint256 timestamp)",
  "event ROIEarned(uint256 indexed userId, uint256 amount, uint256 investmentIndex)",
  "event LevelIncomeEarned(uint256 indexed userId, uint256 amount, uint256 level, uint256 indexed fromUserId)",
  "event DirectReferralEarned(uint256 indexed userId, uint256 amount, uint256 indexed fromUserId)",
  "event ClubIncomeEarned(uint256 indexed userId, uint256 clubLevel, uint256 amount)",
  "event RewardsClaimed(uint256 indexed userId, uint256 amount)"
];

export const ERC20_ABI = [
  "function name() view returns (string)",
  "function symbol() view returns (string)",
  "function decimals() view returns (uint8)",
  "function balanceOf(address) view returns (uint256)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) returns (bool)",
  "function transfer(address to, uint256 amount) returns (bool)",
  "function transferFrom(address from, address to, uint256 amount) returns (bool)"
];
